import { tasOccurrence } from "../types";
import useDarkMode from "../../../hooks/useDarkMode";

interface Props {
    type: string;
}

const Chip = ({ type }: Props) => {
    const isDarkMode = useDarkMode();

    const config = {
        "TECHNICAL_SUPPORT": {
            bg: isDarkMode ? '#0c2d3d' : '#F0F9FF',
            color: isDarkMode ? '#7cd4fd' : '#026AA2',
            borderColor: isDarkMode ? '#164e63' : '#B9E6FE',
            text: 'TAS',
        },
        "VOLKSTOTAL": {
            bg: isDarkMode ? '#262626' : '#F9FAFB',
            color: isDarkMode ? '#d4d4d4' : '#344054',
            borderColor: isDarkMode ? '#404040' : '#E4E7EC',
            text: 'Volkstotal',
        }
    }

    const result = config[type as keyof typeof config] || config?.VOLKSTOTAL;

    return (
        <div className="height-22 rounded-lg border display-flex justify-content-center" style={{ background: result.bg, color: result.color, borderColor: result.borderColor, padding: '2px 14px', borderRadius: 16, textAlign: 'center' }}>
            <span className="text-size-12 text-medium">{result?.text}</span>
        </div>
    );
};

export default Chip;